import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { query, searchFacetChange, setFilterTabOpen } from '../Actions/FacetedSearch.action';
import { Svg } from './Svg';
const FacetedSearchGroup = ({ group }) => {
    const list = useRef(null);
    const listTop = useRef(null);
    const firstRender = useRef(true);
    const expandFilters = useCallback((group) => {
        group.expanded = !group.expanded;
        var domGroup = document.getElementById(group.id);
        if (group.expanded) {
            domGroup.classList.add("expanded");
        }
        else {
            domGroup.classList.remove("expanded");
        }
    }, []);
    useEffect(() => {
        // Make sure it is executed only once.
        // firstRender is used to prevent eslint warning when having empty dependencies array
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;
    }, [group]);
    const chevronClass = group.expanded ? "chevron-up" : "chevron-down";
    return (_jsx(Fragment, { children: _jsxs("ul", { id: group.id, className: `faceted-search__group ${group.expanded ? "expanded" : ""}`, role: "group", ref: list, children: [_jsxs("div", { className: "faceted-search__group-header-row", onClick: () => expandFilters(group), children: [_jsx("div", { className: "faceted-search__group-header", children: group.label }), _jsx("span", { className: "faceted-search__group-header__arrow", children: _jsx(Svg, { icon: "chevron", extraClass: chevronClass }) })] }), group.options &&
                    group.options.map((item, itemIndex, array) => (_jsx("li", { className: "faceted-search__item", role: "menuitemcheckbox", children: _jsx(FacetedFilterCheckbox, { item: item, group: group }) }, `${item.label}-${itemIndex}`)))] }) }));
};
const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback((group, item) => dispatch(searchFacetChange(group, item)), [dispatch]);
    return (_jsxs("label", { className: "faceted-filter", children: [_jsxs("span", { className: "faceted-filter__label", title: item.label, children: [item.label, !isNaN(item.quantity) && item.quantity != null && group.id !== "ProducerName" && (_jsxs("span", { className: "faceted-filter__quantity", children: ["\u00A0(", item.quantity, ")"] }))] }), _jsx("input", { className: "faceted-filter__input", type: "checkbox", onChange: (event) => onChange(group, item), id: item.id, checked: group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id) }), _jsx("label", { className: "faceted-filter__virtual-checkbox", htmlFor: item.id })] }));
};
const FacetedSearch = () => {
    const dispatch = useDispatch();
    const { facetFilters, navigationTheme, filterTabOpen } = useSelector((state) => state.facetedSearch);
    let statusClass = filterTabOpen ? "" : "hide-filter closed";
    useEffect(() => {
        // listen to history events (back, forward) of window
        window.onpopstate =
            window.onpopstate ||
                ((event) => {
                    dispatch(query(window.location.search.substr(1) || ''));
                });
    }, [dispatch]);
    return (navigationTheme !== 'category' &&
        facetFilters &&
        facetFilters.length > 0 && (_jsx("aside", { id: "product-filter", className: `columns product-filtering subnav-filter ${statusClass}`, children: _jsxs("div", { className: "faceted-search", role: "menu", children: [_jsxs("div", { className: "faceted-search__top-menu", children: [_jsxs("div", { className: "faceted-search__top-menu__header", children: [_jsx(Svg, { icon: "filter", extraClass: "category-page__filter-section__menu" }), translate('nmas.category.filter')] }), _jsx("button", { id: "close-filter", onClick: () => dispatch(setFilterTabOpen(false)), className: "close-filter-button", children: _jsx(Svg, { icon: "close" }) })] }), facetFilters.map((group, groupIndex) => (_jsx(FacetedSearchGroup, { group: group }, `${group.label}-${groupIndex}`)))] }) })));
};
export default FacetedSearch;
